import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import {
  Table as TableMui,
  TableBody as TableBodyMui,
  TableCell as TableCellMui,
  TableContainer as TableContainerMui,
  Button,
  Typography,
} from "@mui/material";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 25px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
`;

export const ImportantNotice = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  margin-bottom: 10px;
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 20px;
  align-items: end;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
`;

export const AddButton = styled(Button)`
  background-color: ${({ theme }) => theme.palette.primary.main} !important;
  color: white !important;
  text-transform: none !important;
  font-weight: 500 !important;
  padding: 8px 24px !important;
  width: fit-content !important;
  height: 42px !important;
  border-radius: 21px !important;
  box-shadow: none !important;

  &:hover {
    background-color: ${({ theme }) => theme.palette.primary.dark} !important;
  }

  @media (max-width: 768px) {
    width: 100% !important;
  }
`;

export const TableContainer = styled(TableContainerMui)`
  background-color: ${({ theme }) => theme.palette.background.paper};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
`;

export const Table = styled(TableMui)`
  & .MuiTableCell-root {
    border-color: #e0e0e0 !important;
  }
`;

export const TableBody = styled(TableBodyMui)`
  & .MuiTableCell-root {
    border-color: #e0e0e0 !important;
  }
`;

export const TableCell = styled(TableCellMui)`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
  border-bottom: 1px solid #e0e0e0;
`;

export const EmptyTableCell = styled(TableCell)`
  text-align: center;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-style: italic;
  padding: 40px 16px;
  border-bottom: none;
`;

export const ImportantLabel = muiStyled("span")({
  fontWeight: 500,
});

export const EmptyStateTypography = muiStyled(Typography)({
  color: "rgba(0, 0, 0, 0.38)",
});
